import { motion, AnimatePresence } from 'framer-motion';
import { X, Eye } from 'lucide-react';

interface TransparenceRadicaleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function TransparenceRadicaleModal({ isOpen, onClose }: TransparenceRadicaleModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-sky-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-sky-500/30 shadow-2xl shadow-sky-500/20"
          >
            <div className="relative p-8 border-b border-sky-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-sky-500 to-blue-500 rounded-xl">
                    <Eye className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-blue-400">
                      Transparence Radicale
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Valeur BZ: transparence radicale</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-sky-600/20 via-blue-600/20 to-sky-600/20 rounded-xl p-8 border-2 border-sky-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Client d'abord</h3>
                <p className="text-gray-300 text-center text-lg">
                  <strong className="text-white">CodeHub visible et à jour</strong>. 
                  Notre code = leur application. <strong className="text-sky-400">Visibilité 100%</strong>.
                </p>
              </div>
              <div className="bg-gradient-to-br from-sky-500/10 to-blue-500/10 rounded-xl p-6 border border-sky-500/30">
                <h4 className="text-xl font-bold text-white mb-4">KPI : Visibilité 100%</h4>
                <p className="text-gray-300">Tous les clients ont accès à CodeHub et peuvent voir l'avancement de leur projet en temps réel.</p>
              </div>
            </div>
            <div className="p-6 border-t border-sky-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-sky-500 to-blue-500 text-white rounded-xl hover:from-sky-600 hover:to-blue-600 transition-all duration-200 font-semibold shadow-lg shadow-sky-500/20 hover:shadow-sky-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

